import AdminPanelPage from './container';

export default AdminPanelPage;
